import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, DownloadIcon, EnvelopeIcon, FireIcon } from './Icons';
import { trackAddToCart } from './MetaPixel';
export function PricingCTA() {
  const features = ['55 páginas de neurociencia aplicada', 'Protocolo completo de 21 días', '7 plantillas de Escritura Neural', 'Tabla de seguimiento imprimible', 'Checklist de los 7 síntomas', 'Glosario RNS 12 términos clave', 'Descarga inmediata en PDF'];
  return <section id="pricing" className="bg-primary py-10 md:py-16 px-4 md:px-12 scroll-mt-20" data-id="element-229">
      <div className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-230">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-231">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-gold" data-id="element-232">
            Comienza tu Reprogramación Hoy
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full max-w-[560px] bg-secondary border border-gold rounded-2xl p-6 md:p-10 shadow-glow-gold relative overflow-hidden" data-id="element-233">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-dark via-gold to-gold-dark" data-id="element-234"></div>

          <div className="text-center mb-6 md:mb-8" data-id="element-235">
            <h3 className="font-playfair font-bold text-2xl md:text-3xl text-warm-white mb-2" data-id="element-236">
              El Protocolo RNS
            </h3>
            <p className="font-inter text-sm md:text-base text-warm-muted" data-id="element-237">
              Re-programa tu Cerebro para Atraer y Retener Dinero en 21 Días
            </p>
          </div>

          <div className="w-full h-px bg-card mb-6 md:mb-8" data-id="element-238"></div>

          <div className="flex flex-col items-center mb-6 md:mb-8" data-id="element-239">
            <div className="text-warm-disabled line-through font-inter text-base md:text-lg mb-2" data-id="element-240">
              Valor real: $37
            </div>
            <div className="bg-gold/10 border border-gold/30 text-gold font-bold px-3 py-1 rounded-full text-sm mb-4 flex items-center gap-2" data-id="element-241">
              <FireIcon className="w-4 h-4" data-id="element-242" /> 83% DE DESCUENTO
            </div>
            <div className="font-playfair font-extrabold text-6xl md:text-7xl text-gold mb-2" data-id="element-243">
              $6.39
            </div>
            <div className="text-warm-muted font-inter text-sm" data-id="element-244">
              Precio de lanzamiento
            </div>
          </div>

          <a href="https://pay.hotmart.com/I105463361U" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full text-center bg-gold hover:bg-gold-light transition-all text-primary font-inter font-bold text-base md:text-lg px-6 py-4 md:py-5 rounded-xl shadow-glow-gold hover:shadow-glow-gold-lg mb-5 md:mb-6 transform hover:-translate-y-1" data-id="element-245">
            QUIERO EL PROTOCOLO RNS POR SOLO $6.39
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-warm-muted text-xs font-inter" data-id="element-246">
            <div className="flex items-center gap-1.5" data-id="element-247">
              <LockIcon className="w-4 h-4" data-id="element-248" /> Pago 100% Seguro
            </div>
            <span className="hidden sm:inline text-warm-disabled" data-id="element-249">•</span>
            <div className="flex items-center gap-1.5" data-id="element-250">
              <DownloadIcon className="w-4 h-4" data-id="element-251" /> Descarga Inmediata
            </div>
            <span className="hidden sm:inline text-warm-disabled" data-id="element-252">•</span>
            <div className="flex items-center gap-1.5" data-id="element-253">
              <EnvelopeIcon className="w-4 h-4" data-id="element-254" /> Enviado a tu Email
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}